import React, { useEffect, useState } from "react";
import UiFormControlSelection from "../../common/ui/UiFormControlSelection";
import UiFormField from "../../common/ui/UiFormField";
interface State {
  name: string;
  abbrev: string;
}

export default function StateTaxesForm(props: any) {
  const [formFields, setFormFields] = useState<any>({});
  const { employeeState } = props;
  const renderFormfields = (formField: any, index: number) => {
    const fieldType = formField?.input_question_format?.type;
    const options = formField?.input_question_format?.options;
    const description = formField?.description;
    if (fieldType === "Select") {
      return (
        <div className="state-taxes__form-field" key={index}>
          <UiFormControlSelection
            label={formField.label}
            type="select"
            optionsData={options}
            optionKey="label"
            optionValue="value"
            fieldName={formField.key}
            required={true}
            showFloatingLabel={true}
          />
          {description && (
            <p dangerouslySetInnerHTML={{ __html: description }}></p>
          )}
        </div>
      );
    }
    if (fieldType === "radio") {
      return (
        <div className="state-taxes__form-field" key={index}>
          <label>{formField.label}</label>
          <UiFormControlSelection
            type="radio"
            label={formField.label}
            fieldName={formField.key}
            radioOptionsData={options}
          />
        </div>
      );
    }
    if (fieldType === "Number") {
      return (
        <div className="state-taxes__form-field" key={index}>
          <UiFormControlSelection
            type="number"
            label={formField.label}
            showFloatingLabel={true}
            fieldName={formField.key}
          />
          {description && (
            <p dangerouslySetInnerHTML={{ __html: description }}></p>
          )}
        </div>
      );
    }
    if (fieldType === "Currency") {
      return (
        <div className="state-taxes__form-field" key={index}>
          <UiFormControlSelection
            type="currency"
            label={formField.label}
            showFloatingLabel={true}
            fieldName={formField.key}
          />
          {description && (
            <p dangerouslySetInnerHTML={{ __html: description }}></p>
          )}
        </div>
      );
    }
    if (fieldType === "Text") {
      return (
        <div className="state-taxes__form-field" key={index}>
          <UiFormField
            type="text"
            placeholder={formField.label}
            label={formField.label}
            labelSize={false}
            fieldName={formField.key}
            showFloatingLabel={true}
          />
        </div>
      );
    }
  };
  const isEmpty = (obj) => {
    return Object.keys(obj).length === 0;
  };
  const mapFormFields = () => {
    if (!formFields || isEmpty(formFields)) return;
    return formFields.map((field: any, index: number) => {
      return renderFormfields(field, index);
    });
  };

  useEffect(() => {
    setFormFields(props?.employeeData?.questions);
  }, [props]);
  return (
    <>
      <div className="state-taxes__form-field">
        <UiFormControlSelection
          type="select"
          optionsData={employeeState}
          optionValue="id"
          fieldName="state"
          optionKey="name"
          showFloatingLabel={true}
          disabled={true}
        />
        <p>
          Your job’s address determines the State you will be paying taxes in.
        </p>
      </div>
      {mapFormFields()}
    </>
  );
}
